import { StatusTag, TableCustomCellWrapper } from "../components";

const setTableDirectionOnSort = (
  columns,
  setColumns,
  column,
  sortDirection,
  setDefaultSortFieldId
) => {
  setColumns(
    columns.map((col) => {
      if (col.id === column.id) {
        return {
          ...col,
          sortDirection,
        };
      } else {
        return {
          ...col,
          sortDirection: null,
        };
      }
    })
  );
  setDefaultSortFieldId(column.id);
};

const getColumnStatusColumn = (selector) => {
  return {
    id: "status",
    name: "Status",
    selector,
    cell: (row) => (
      <TableCustomCellWrapper row={row} isLoadingSkeleton={() => !row?.id}>
        <StatusTag status={selector(row)} />
      </TableCustomCellWrapper>
    ),
    sortable: false,
    sortDirection: null,
    width: "15%",
  };
};

export { setTableDirectionOnSort, getColumnStatusColumn };
